'use strict';
import {Dialog} from './dialog.js';

export class DialogPapromomy extends Dialog {
	constructor(component_key) {
		super(component_key);
	}

	init() {
		super.init();
		yalwa.basics.ga.datalayer({
			event: this.get_full_dl_event_name('promo_plp')
		});
	}
	
	get_dl_prefix_name_by_promo_type() {
		return (this.component.type === 'three_tiers') ? 'premium_account' : 'vip_account'
	}
	
	get_full_dl_event_name(event_name) {
		return this.get_dl_prefix_name_by_promo_type() + '_' + event_name;
	}
	
	add_events() {
		// Generic close event
		if(this.$dialog.hasClass(`js-${this.component.component_type}_close`)) {
			this.$dialog.off('click.close').on('click.close', (e) => {
				
				// Only close if the click was directly on the background overlay, not bubbled from content
				if (e.target === e.currentTarget || jQuery(e.target).hasClass('dialog__position')) {
					this.hide();
				}
				
				if (jQuery(e.target).hasClass('js-dialog_close')) {
					yalwa.basics.ga.datalayer({
						event: this.get_full_dl_event_name('promo_plp_clicks'),
						'click_touchpoint': this.get_full_dl_event_name('plp_close')
					});
				} else {
					yalwa.basics.ga.datalayer({
						event: this.get_full_dl_event_name('promo_plp_clicks'),
						'click_touchpoint': this.get_full_dl_event_name('plp_upgrade')
					});
				}
				
			});
		}
		if (this.$trigger) {
			this.$trigger.on('click', this.show.bind(this));
		}
		this.$dialog.find(`.js-${this.component.component_type}_close`).off('click.close').on('click.close', this.hide.bind(this));
	}
}